export default __webpack_public_path__ + "static/media/my-flag.2d917468.svg";